import { render, staticRenderFns } from "./AFCEditor.vue?vue&type=template&id=a6f5dfb0&scoped=true"
import script from "./AFCEditor.vue?vue&type=script&lang=js"
export * from "./AFCEditor.vue?vue&type=script&lang=js"
import style0 from "./AFCEditor.vue?vue&type=style&index=0&id=a6f5dfb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f5dfb0",
  null
  
)

export default component.exports